const SELECTORS = {
  dropdown: '.topbar-dropdown',
  anchors: '.disclosure-list .disclosure-list__item a[href="SHOP_DOMAIN"] button',
  currentSelect: '.disclosure__toggle .disclosure__toggle-content',
};

const dropdowns = document.querySelectorAll(SELECTORS.dropdown);
dropdowns.forEach((dropdown) => {
  const currentSelect = dropdown.querySelector(SELECTORS.currentSelect);

  let textElement = null;

  if (window.location.href.replace(window.location.origin, '').slice(0, 3) === 'de') {
    textElement = dropdown.querySelector(SELECTORS.anchors.replace('SHOP_DOMAIN', window.location.origin + '/de'));
  } else {
    textElement = dropdown.querySelector(SELECTORS.anchors.replace('SHOP_DOMAIN', window.location.origin))
    || dropdown.querySelector(SELECTORS.anchors.replace('SHOP_DOMAIN', window.location.origin + '/'));
  }

  const text = textElement?.textContent.trim();

  if (currentSelect && text !== undefined && text !== '') {
    currentSelect.innerText = text;
  }
});
